import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { colors } from '../../constants/theme';
import { SOCIAL_LINKS } from '../../constants/socialLinks';

// Horizontal row of Nirva social icons. Shared by the Footer and the mobile
// navigation drawer so they stay visually identical.
const Row = styled(Box)({
  display: 'flex',
  gap: '16px',
});

const RowLink = styled('a')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '38px',
  height: '38px',
  color: colors.secondary,
  transition: 'opacity 0.2s ease, transform 0.2s ease',
  '&:hover': {
    opacity: 0.8,
    transform: 'scale(1.1)',
  },
  '& svg': {
    fontSize: '20px',
  },
});

const SocialRow = (props) => {
  return (
    <Row {...props}>
      {SOCIAL_LINKS.map(({ name, url, Icon }) => (
        <RowLink
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
        >
          <Icon />
        </RowLink>
      ))}
    </Row>
  );
};

export default SocialRow;
